import { render, staticRenderFns } from "./open-new.vue?vue&type=template&id=3442b37f"
import script from "./open-new.vue?vue&type=script&lang=js"
export * from "./open-new.vue?vue&type=script&lang=js"
import style0 from "./open-new.vue?vue&type=style&index=0&id=3442b37f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3442b37f')) {
      api.createRecord('3442b37f', component.options)
    } else {
      api.reload('3442b37f', component.options)
    }
    module.hot.accept("./open-new.vue?vue&type=template&id=3442b37f", function () {
      api.rerender('3442b37f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tickets/open-new.vue"
export default component.exports